import { WebNovelViewer } from "../../feature/viewer/WebNovelViewer.js";

export class WebnovelPreview {
    constructor(container, props) {
        this.container = container;
        this.props = props; // { data, activeChapter }
    }

    async render() {
        this.container.innerHTML = '';

        const currentChap = this.props.activeChapter;
        const seriesData = this.props.data;

        if (!currentChap) {
            this.container.innerHTML = '<div class="text-zinc-500 text-xs text-center p-10">No Chapter Selected</div>';
            return;
        }

        // Mock Navigation Callbacks
        const noop = () => { };

        // Reuse the main WebNovelViewer component
        // Note: WebNovelViewer handles its own DOM structure/styles mostly
        const viewer = await WebNovelViewer(this.container, {
            title: currentChap.title,
            content: currentChap.content,
            note: currentChap.note,
            bgmUrl: currentChap.bgmUrl, // Ensure BGM is passed if viewer supports it
            isbn: seriesData.isbn,
            uci: seriesData.uci,

            // Preview Flags
            isPreview: true,
            hasPrev: false,
            hasNext: false,
            onPrev: noop,
            onNext: noop,

            // Disable certain interactions in preview
            hideComments: true,
        });

        // The Viewer appends itself, so we might not need to do anything else.
        // However, WebNovelViewer return value might vary (HTMLElement or void).
        // Based on analysis, it appends to container.
    }
}
